import React from 'react';
import _ from 'lodash';
import makeStyles from '@mui/styles/makeStyles';

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';

import { SearchInput } from 'widgets-v6/standard-input';
import { CanSwitch, CanCase } from 'containers/can';

import GlobalRefresh from 'containers/global-refresh';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    body: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'auto',
    },
}));

class DashboardLayoutHeader extends React.Component {
    constructor(props) {
        super(props);

        this.handleSearchTextDebounced = _.debounce(text => {
            this.props.searchCampaigns(text);
        }, 200);
    }

    UNSAFE_componentWillMount() {
        this.handleChangeSearchText = value => {
            this.props.filterByText(value);
        };
    }

    componentDidMount() {
        if (this.refs.dashboardSearch) {
            this.refs.dashboardSearch.focus();
            this.refs.dashboardSearch.select();
        }
    }

    selectAllSearchText = () => {
        if (this.refs.dashboardSearch) {
            this.refs.dashboardSearch.select();
        }
    };

    handleSearchText = e => {
        this.handleSearchTextDebounced(e.target.value);
    };

    render() {
        const { pagination, searchQueryString, searchInputRef, resetSearchValue } = this.props;

        return (
            <div>
                <Box display="flex" justifyContent="space-between" mt={2} alignItems="center">
                    <div className="ef6-alignment__flex">
                        <Typography variant="h4">All Campaigns</Typography>
                        <div style={{ marginLeft: 3 }}>
                            <GlobalRefresh isLoading={pagination.isLoading} />
                        </div>
                    </div>
                    <div className="ef6-dashboard__action-buttons">
                        <CanSwitch>
                            <CanCase intent="campaign__view_and_edit">
                                {this.props.callToAction}
                            </CanCase>
                        </CanSwitch>
                    </div>
                </Box>
                <Box mt={2}>
                    <Box maxWidth="300" mb={2}>
                        <SearchInput
                            id="dashboard-campaign-search"
                            placeholder="Search by Campaign or Netsuite ID"
                            onChange={this.handleSearchText}
                            defaultValue={searchQueryString}
                            inputRef={searchInputRef}
                            onReset={resetSearchValue}
                        />
                    </Box>
                </Box>
            </div>
        );
    }
}

export default function DashboardLayout(props) {
    const classes = useStyles();

    const {
        pagination,
        filterByText,
        dashboardCampaignList,
        goToNewCampaignForm,
        searchQueryString,
        searchInputRef,
        resetSearchValue,
        searchCampaigns,
    } = props;

    return (
        <div className={classes.root}>
            <Container>
                <DashboardLayoutHeader
                    resetSearchValue={resetSearchValue}
                    searchInputRef={searchInputRef}
                    searchQueryString={searchQueryString}
                    filterByText={filterByText}
                    pagination={pagination}
                    callToAction={
                        <Button
                            onClick={goToNewCampaignForm}
                            color="primary"
                            variant="contained"
                            startIcon={<AddIcon />}
                        >
                            New Campaign
                        </Button>
                    }
                    classes={classes}
                    searchCampaigns={searchCampaigns}
                />
                <div className={classes.body}>{dashboardCampaignList}</div>
            </Container>
        </div>
    );
}
